import React, { Component } from 'react';
import Header from '../Header/Header';
import SearchBar from '../SearchBar/SearchBar';
import Cards from '../Cards/Cards';
import { InputProps } from '../../shared/Types';

import './Home.scss';

export default class Home extends Component<InputProps> {
  constructor(props: InputProps) {
    super(props);
  }

  render() {
    return (
      <div data-testid="home-page">
        <Header page="Home Page" />
        <main className="main">
          <div className="wrapper main__container">
            <SearchBar />
            <Cards />
          </div>
        </main>
      </div>
    );
  }
}
